// extracted by mini-css-extract-plugin
module.exports = {"tipFooter":"index_tipFooter__9WYWL","copyright":"index_copyright__29AzD","description":"index_description__1CR9z"};